import { capitalize, InputAdornment, TextField } from "@mui/material";
import React, { useContext, useEffect } from "react";
import DataContext from "../../Context/DataContext";

function TextInput({
  id,
  name,
  title,
  type,
  required,
  value,
  defaultValue,
  error,
  helper_text,
  handleFunction,
  rowId,
  multiple,
  sectionTitle,
  disabled = false,
  style,
  endIcon,
  startIcon,
}) {
  const { handleGetMultipleInputs } = useContext(DataContext);
  const getValues = (value) => {
    let returnValue;
    if (name === "PAN_CARD" || name === "DRIVING_LICENCE") {
      returnValue = value?.toUpperCase();
    } else {
      returnValue = value;
    }

    return returnValue;
  };
  return (
    <div style={{ textAlign: "start", ...style }}>
      <span style={{ padding: "0 4px", color: "#6e6e6e" }}>
        <label>{title}{required && <span style={{color:'red'}}>*</span>}</label>
      </span>
      <TextField
        sx={{
          ...style,
          margin: "4px 0",
          "& input[type=number]": {
            MozAppearance: "textfield",
          },
          "& input[type=number]::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
          "& input[type=number]::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
        }}
        fullWidth
        id={id}
        name={name}
        disabled={disabled}
        
        // label={title}
        value={getValues(value)}
        defaultValue={defaultValue}
        renderinput={(val) => `-${val}`}
        type={type}
        placeholder={`Enter ${title}`}
        error={error}
        helperText={helper_text}
        onChange={(e) =>
          multiple
            ? handleGetMultipleInputs(e, rowId, id, sectionTitle)
            : handleFunction(e)
        }
        size="small"
        slotProps={{
          inputLabel: { shrink: true },
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <span style={{ fontFamily: "sans-serif", fontSize: "15px" }}>
                  {startIcon}
                </span>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <span style={{ fontFamily: "sans-serif", fontSize: "15px" }}>
                  {endIcon}
                </span>
              </InputAdornment>
            ),
          },
        }}
      />
    </div>
  );
}

export default TextInput;
